import { Theme } from '@mui/material'

import { getChatbotAccentColor } from '~/features/chatbot/utils'
import {
  EChatbotTheme,
  TChatbotSettingsLayout,
} from '~/features/settings/models'
import { getWhiteOrBlackTextColorByBackground } from '~/utils/ui'

export const getMessageColors = (
  chatbotLayout: TChatbotSettingsLayout,
  theme: Theme,
) => {
  const selectedTheme = chatbotLayout.selection.theme
  const { accentColor: linkViewAccentColor } = getChatbotAccentColor({
    layout: chatbotLayout,
    selectedTheme: EChatbotTheme.linkView,
  })

  const userColor = {
    [EChatbotTheme.simple]: theme.palette.common.white,
    [EChatbotTheme.linkView]: getWhiteOrBlackTextColorByBackground(
      linkViewAccentColor,
      theme,
    ),
  }[selectedTheme]
  const botColor = theme.palette.mainFont

  const userBackgroundColor = {
    [EChatbotTheme.simple]: chatbotLayout.selection[EChatbotTheme.simple],
    [EChatbotTheme.linkView]: linkViewAccentColor,
  }[selectedTheme]

  const botBackgroundColor = theme.palette.common.white

  return { userColor, botColor, userBackgroundColor, botBackgroundColor }
}

export function safeHttpHref(href: string | undefined): string | null {
  if (href == null || href === '') {
    return null
  }
  const t = href.trim()
  if (!t) {
    return null
  }
  try {
    let u: URL
    if (/^[a-z][a-z0-9+.-]*:/i.test(t)) {
      u = new URL(t)
    } else if (t.startsWith('//')) {
      u = new URL(`https:${t}`)
    } else {
      u = new URL(`https://${t}`)
    }
    if (u.protocol !== 'http:' && u.protocol !== 'https:') {
      return null
    }
    if (u.protocol === 'http:' && u.hostname.toLowerCase().startsWith('www.')) {
      u.protocol = 'https:'
    }
    return u.href
  } catch {
    return null
  }
}

export default getMessageColors
